<p-dialog header="Create Report" [(visible)]="createReportVisible" [modal]="true" [closable]="false"
    [style]="{width:'60vw'}">
    <div class="row">
        <span class="h2">{{itemCount | number}}</span>
        <p>Items selected for report.</p>
        <p *ngIf="itemCount > docMax"><b><i><span class="h5">NOTE:</span> <br /> You have selected more than the maximum number of documents ({{docMax | number}}) that can be retrieved for a report. <br /> Only the first {{docMax | number}} items will be included!!</i></b></p>
    </div>
    <div class="row">
        <div class="col-12">
            <p><span class="h6">NOTE: </span><i>Document Title, Accession Number, Date Added and Url will be included in all Reports by
                default!</i></p>
            <p class="me-3 mt-2 mb-2"><span class="h5 me-3">Choose Format:</span>
                <p-radioButton name="reportType" [(ngModel)]="reportType" inputId="excel" value="Excel"
                    ariaLabel="Download Excel"></p-radioButton>&nbsp;<i class="fa fa-file-excel"
                    style="color:green!important;"></i> Excel (recommended)
                <p-radioButton name="reportType" [(ngModel)]="reportType" inputId="csv" value="CSV"
                    arialabel="Download CSV" class="ms-3"></p-radioButton>&nbsp;<i class="fa fa-file-csv"
                    style="color:darkorange!important;"></i> CSV
            </p>
        </div>
        <div class="col-12">
            <p><span class="h5 me-3">Choose Properties:</span>
                <p-radioButton name="propertyOption" [(ngModel)]="propertyOption" (ngModelChange)="clearValidation()"
                    inputId="all" value="all" ariaLabel="All Properties" value="all"></p-radioButton>&nbsp; All
                Properties
                <p-radioButton name="propertyOption" [(ngModel)]="propertyOption" (ngModelChange)="clearValidation()"
                    inputId="selected" value="selected" class="ms-3" arialabel="Selected Properties"
                    value="selected"></p-radioButton> Selected
                Properties
            </p>
        </div>
    </div>
    <div *ngIf="propertyOption==='selected'" class="row">
        <div *ngFor="let prop of props; let i=index;" class="col-4 field-checkbox mb-1">
            <p-checkbox name="propGroup" [value]="prop" [(ngModel)]="selectedProperties"
                [inputId]="prop.id"></p-checkbox>
            <label class="ms-2" [for]="prop.id">{{ prop.displayName }}</label>
        </div>
    </div>
    <div *ngIf="propertyOption==='all'" class="row">
        <div class="col-12 text-align-center">
            <p class="mt-2 h4">All document properties will be included in the report!</p>
        </div>
    </div>
    <div *ngIf="selectionInvalid==true" class="row mt-2">
        <div class="col-12 text-align-center">
            <small class="text-danger"><b><i class="pi pi-exclamation-circle me-2"></i>Please select at least 1 property
                    to be included in the report or chose 'All Properties'</b></small>
        </div>
    </div>
    <div class="float-end">
        <button p-button class="btn btn-primary mt-3 mb-3 me-3" (click)="executeClose();"><span
                class="fas fa-circle-xmark"></span> Close
        </button>
        <button p-button class="btn btn-secondary mt-3 mb-3" [disabled]="itemCount < 1" (click)="executeReport();"> <span
                class="pi pi-download"></span> Create Report</button>
    </div>
</p-dialog>
